import { DetailItem } from 'app/shared/info-section/item';
import ReactJson from 'react-json-view';
import React from 'react';

export const LogView = ({ log }) => {
  return (
    <div>
      <DetailItem title="Id">{log.id}</DetailItem>
      <DetailItem title="Type">{log.type}</DetailItem>
      <DetailItem title="Message">{log.message}</DetailItem>
      <DetailItem title="Creation date">{log.created_on}</DetailItem>
      <DetailItem title="Metadata">
        <ReactJson theme="monokai" src={log.meta} />
      </DetailItem>
    </div>
  );
};
